import React, { FC, memo } from "react";
import { chakra, useCheckbox } from "@chakra-ui/react";
import { CheckedCircleIcon, UncheckedCircleIcon } from "modules/icons";
import { ICheckboxProps } from "modules/utils/Constants";
import colors from "app/colors";

const CircularCheckbox: FC<ICheckboxProps> = ({ ...rest }) => {
  const { state, getInputProps } = useCheckbox(rest);

  const icon = (() =>
    state.isChecked ? (
      <CheckedCircleIcon fill={colors.blue} />
    ) : (
      <UncheckedCircleIcon />
    ))();

  return (
    <chakra.label cursor="pointer">
      <input {...getInputProps()} hidden />
      {icon}
    </chakra.label>
  );
};
export default memo(CircularCheckbox);
